import queryString from 'query-string'
import payParam from '@/assets/js/payParam'

export default {
  data: function () {
    return {
      payCallbackParams: null,
      payCallbackParamList: ['extra_common_param', 'r8_MP']
    }
  },
  created: function () {
    this.getPayCBParams()
  },
  methods: {
    getPayCBParams: function () {
      let query = queryString.parse(location.search)

      for (let i = 0; i < this.payCallbackParamList.length; i++) {
        let firstQuery = query[this.payCallbackParamList[i]]

        if (firstQuery) { // 只取第一个符合匹配的回调参数
          this.payCallbackParams = payParam.parseExtraParam(firstQuery)
          break
        }
      }
    }
  }
}
